import { Client } from '@bugsnag/core'
import { isServer } from '@/utils/app/detect'
import { getBugsnagConfig } from '@/config/config'

let client: Client | undefined = undefined

const getBugsnagClient = () => {
  if (isServer()) {
    return undefined
  }
  const Bugsnag = require('@bugsnag/js').default
  const config = getBugsnagConfig()

  if (!client || !Bugsnag.isStarted()) {
    try {
      client = Bugsnag.start({
        apiKey: config?.apiKey,
        appType: 'server',
        endpoints: {
          notify: config?.notifyUrl,
          sessions: config?.sessionsUrl,
        },
        autoDetectErrors: true,
        autoTrackSessions: true,
        enabledReleaseStages: ['prod', 'preprod', 'preview', 'development'],
        releaseStage: config?.releaseStage,
        appVersion: config?.appVersion,
      })
      console.log('[Bugsnag] Loaded!')
    } catch (e: any) {
      console.warn(`[Bugsnag] Error during initialization cause of ${e.message}`)
    }
  }
  return client
}

export default getBugsnagClient
